import { makeStyles } from '@material-ui/core/styles'
import { BENCHMARK_COLORS } from './benchmark-chips'

const TRACK_COLOR = BENCHMARK_COLORS.neutral.track
const ICON_CIRCLE_BACKGROUND = '#EBF0F2'
const ICON_CIRCLE_COLOR = '#172024'

const useStyles = makeStyles(theme => ({
  section: {
    marginTop: 0,
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    minWidth: 0,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    borderBottom: '1px solid #E0E0E0',
  },
  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  cardTitleBlock: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    minWidth: 0,
  },
  iconCircle: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: ICON_CIRCLE_BACKGROUND,
    color: ICON_CIRCLE_COLOR,
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
  cardTitle: {
    color: '#172024',
  },
  cardSubtitle: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
  cardAction: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  sampleNotice: {
    padding: theme.spacing(2, 3),
    borderBottom: '1px solid #E0E0E0',
    fontSize: '0.8125rem',
    lineHeight: 1.45,
    color: theme.palette.text.secondary,
    backgroundColor: '#F5F8FF',
  },
  metricList: {
    padding: 0,
  },
  metricRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(160px, 220px) minmax(0, 1fr) auto',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.02)',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      alignItems: 'flex-start',
      gap: theme.spacing(1.5),
    },
  },
  metricLabelCell: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    minWidth: 0,
    paddingTop: theme.spacing(0.25),
  },
  metricLabelText: {
    minWidth: 0,
  },
  metricIconCircle: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: ICON_CIRCLE_BACKGROUND,
    color: ICON_CIRCLE_COLOR,
    '& .MuiSvgIcon-root': {
      fontSize: 14,
    },
  },
  metricLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: 1.3,
    color: '#172024',
  },
  metricVisual: {
    minWidth: 0,
  },
  barTrack: {
    position: 'relative',
    height: 8,
    borderRadius: 4,
    backgroundColor: TRACK_COLOR,
    overflow: 'hidden',
  },
  barFill: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    borderRadius: 4,
    transition: 'width 0.2s ease',
  },
  medianMarker: {
    position: 'absolute',
    top: -2,
    bottom: -2,
    width: 1,
    backgroundColor: BENCHMARK_COLORS.neutral.marker,
    transform: 'translateX(-50%)',
    zIndex: 1,
  },
  metricStats: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
    flexWrap: 'nowrap',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      width: '100%',
    },
  },
  metricValues: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
}))

export default useStyles
